import styled from '@emotion/styled';
import { css_background, css_fill, css_if, css_small_down, css_text, css_vh } from '~/emotion/theme';

const Section = styled.section<{ $fill?: boolean; $full?: boolean; $offset: string }>`
	background: ${css_if('$fill', css_fill(), css_background())};
	color: ${css_text()};
	display: flex;
	flex-direction: column;
	height: ${css_if('$full', css_vh(), 'auto')};

	@media (${css_small_down}) {
		height: ${css_if('$full', css_vh(50), 'auto')};
	}

	& + * {
		padding-top: ${({ $offset }) => $offset};
	}

	[data-puck-component] & {
		height: ${css_if('$full', css_vh(), 'auto')};
	}

	[data-puck-component]:has(&) + * > * {
		padding-top: ${({ $offset }) => $offset};
	}
`;

export default function MicrositeRow({
	children,
	fill,
	full,
	offset,
	id,
}: {
	children: React.ReactNode;
	id?: string;
	fill?: boolean;
	full?: boolean;
	offset?: string;
}) {
	return (
		<Section id={id} $fill={fill} $full={full} $offset={offset ?? '0'} className={`row ${fill ? 'fill' : ''}`}>
			{children}
		</Section>
	);
}
